export function renderMultiselectFieldJsxFieldControllerTemplate({
  name,
  fieldContainerClass,
  formLabelWithDescriptionLine,
  selectClass,
  optionItems,
  errorMessageLine
}: {
  name: string
  fieldContainerClass: string
  formLabelWithDescriptionLine: string
  selectClass: string
  optionItems: string
  errorMessageLine: string
}): string {
  return `        <Controller
          control={form.control}
          name="${name}"
          render={({ field }) => (
            <div className="${fieldContainerClass}">
              ${formLabelWithDescriptionLine}
              <select
                id="${name}"
                multiple
                value={Array.isArray(field.value) ? field.value : []}
                onChange={(event) => {
                  field.onChange(Array.from(event.target.selectedOptions, (option) => option.value))
                }}
                onBlur={field.onBlur}
                name={field.name}
                ref={field.ref}
                className="${selectClass} min-h-24 py-2"
              >
${optionItems}
              </select>
${errorMessageLine}
            </div>
          )}
        />`
}
